import { useEffect, useState } from 'react'
import { useLockFn } from 'ahooks'
import { Table, Input, Checkbox, message } from 'antd'
import { ColumnsType } from "antd/es/table";
import { YHDrawer } from '@/components/YhDrawer'
import { useApprovalModel } from "../approvalModel";
import { UserFields } from '../ApprovalTypes';
import debounce from 'lodash/debounce';
import '../approval.less'

interface PropsType {
    onSelectOk: (data: UserFields[]) => void;
}
export const AddApplyDrawer = (props: PropsType) => {
    const { onSelectOk } = props;
    const {
        addApplyDrawer, setAddApplyDrawer,
        dataSource, loadUserData, pgCfg, initPgCfg, clone,
        applys, setApplys,
    } = useApprovalModel()

    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<UserFields[]>([]);
    const [searchKey, setSearchKey] = useState<string>();

    useEffect(() => {
        if (addApplyDrawer) {
            if (applys != null && applys.length > 0) {
                setSelectedRowKeys(applys.map(e => e.code ?? ""));
                setSelectedData(applys)
            }
            loadUserData().then();
        }
        else {
            setSelectedRowKeys([]);
            setSelectedData([])
            //setDuty("");
        }
    }, [addApplyDrawer])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            align: "center",
            width: 40,
            render: (v, r, i) => i + 1
        },
        {
            title: '角色名称',
            dataIndex: 'name',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '角色编号',
            dataIndex: 'code',
            align: "center",
            width: 100,
            ellipsis: true,
        },
        {
            title: '使用人数',
            dataIndex: 'userNum',
            align: "center",
            ellipsis: true,
        }
    ];

    const handleSearch = debounce((data: string) => {
        loadUserData(initPgCfg, { "name": data })
        setSearchKey(data);
    }, 1000)

    const handleDuty = (index: number, data: string) => {
        let user = selectedData[index];
        user = { ...user, job: data };
        selectedData?.splice(index, 1, user);

        setSelectedData(clone(selectedData));
    }

    const handleRadio = (userCode: string, checked: boolean) => {
        if (!checked) {
            setSelectedRowKeys(selectedRowKeys.filter(e => e != userCode));
            setSelectedData(selectedData.filter(e => e.code != userCode));
        }
    }

    const onRow = (record: UserFields, selected: boolean) => {
        let arr = [];
        let list = [];
        if (selected) {
            arr = Array.from(new Set([...selectedRowKeys, record.code ?? ""]));
            list = Array.from(new Set([...selectedData ?? [], record]));
        } else {
            arr = selectedRowKeys.filter(item => { return item !== record.code });
            list = selectedData?.filter(item => item.code !== record.code) ?? []
        }
        setSelectedRowKeys(arr);
        setSelectedData(list);
    };

    const onSelectAll = (selected: boolean, changeRows: UserFields[]) => {
        if (selected) {
            let addSelected: string[] = [];
            let addRows = [];
            for (const item of changeRows) {
                addSelected.push(item.code ?? "");
                addRows.push(item);
            }
            setSelectedRowKeys([...addSelected, ...selectedRowKeys]);
            setSelectedData([...addRows, ...selectedData ?? []]);
        } else {
            setSelectedRowKeys(selectedRowKeys.filter((code) => {
                return !changeRows.some((item) => item.code === code)
            }));
            setSelectedData(selectedData?.filter((data) => {
                return !changeRows.some((item) => item.code === data.code)
            }));
        }
    }

    const onOk = useLockFn(async () => {
        if (selectedRowKeys == null || selectedRowKeys.length == 0) {
            message.error("请选择申请角色");
            return;
        }
        onSelectOk(selectedData);
        setApplys(selectedData);
        setAddApplyDrawer(false);
        setSelectedRowKeys([]);
        setSelectedData([]);
    })


    return (
        <div className='addDrawer-class'>
            <YHDrawer
                {...{
                    title: '申请角色添加',
                    width: 540,
                    visible: addApplyDrawer,
                    closable: true,
                    onOk,
                    onCancel: () => setAddApplyDrawer(false),
                    showFooter: true,
                }}
            >
                <div className="addDrawer-user">
                    <div className="addDrawer-select">
                        <div className="addDrawer-select-search">
                            <Input placeholder="请输入角色名称检索" onChange={e => handleSearch(e.target.value)} />
                        </div>
                        <div className="addDrawer-select-content">
                            <Table
                                rowKey={record => record.code}
                                columns={columns}
                                dataSource={dataSource}
                                rowSelection={{
                                    selectedRowKeys: selectedRowKeys,
                                    onSelectAll: (selected, selectedRows, changeRows) => onSelectAll(selected, changeRows),
                                    onSelect: (record, selected, selectedRows) => onRow(record, selected),
                                }}
                                onRow={record => {
                                    return {
                                        onClick: event => onRow(record, !selectedRowKeys.includes(record.code))
                                    };
                                }}
                                pagination={{
                                    ...pgCfg,
                                    simple: true,
                                    showTotal: (total: number) => `共${total}条`,
                                    position: ["bottomCenter"],
                                    onChange: (pageNum, pageSize) => {
                                        searchKey ? loadUserData({ pageNum, pageSize }, { "name": searchKey }) : loadUserData({ pageNum, pageSize })
                                    }
                                }}
                                scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
                            />
                        </div>
                    </div>
                    <div className="addDrawer-selected">
                        <div className="addDrawer-selected-header">
                            已选角色
                        </div>
                        {selectedData.map((item, index) =>
                            <div className="addDrawer-selected-content">
                                <div className="addDrawer-selected-content-left"><Checkbox checked={true} onChange={(e) => handleRadio(item.code ?? "", e.target.checked)}>{item?.name}</Checkbox></div>
                                {/* <div className="addDrawer-selected-content-right">职位：<Input style={{ width: 200 }} value={item?.job} onChange={(e) => handleDuty(index, e.target.value)} /></div> */}
                            </div>
                        )}
                    </div>
                </div>
            </YHDrawer>
        </div>
    )
}
